// components/dialogs/SendInvitationDialog.jsx
import React, { useState } from "react";
import { Dialog } from "primereact/dialog";
import { InputText } from "primereact/inputtext";
import { Button } from "primereact/button";
import { Tooltip } from "primereact/tooltip";
import { RSVPInvitationPage_pooja } from "../../RSVPInvitationPage/poojainvitationpage/RsvpInvitationpage_pooja";

const SendInvitationDialog = ({
  visible,
  onHide,
  shareUrl,
  shareTitle,
  whatsappMessage,
  image,
  imageloading,
  EventDataForInvitation,
}) => {
  const [copySuccess, setCopySuccess] = useState(false);

  const handleCopy = () => {
    if (navigator.clipboard && navigator.clipboard.writeText) {
      navigator.clipboard
        .writeText(shareUrl)
        .then(() => {
          setCopySuccess(true);
          setTimeout(() => setCopySuccess(false), 2000);
        })
        .catch((err) => {
          console.error("Clipboard API failed, trying fallback...", err);
          fallbackCopyTextToClipboard(shareUrl);
        });
    } else {
      fallbackCopyTextToClipboard(shareUrl);
    }
  };

  const fallbackCopyTextToClipboard = (text) => {
    const textArea = document.createElement("textarea");
    textArea.value = text;
    document.body.appendChild(textArea);
    textArea.focus();
    textArea.select();

    try {
      const successful = document.execCommand("copy");
      if (successful) {
        setCopySuccess(true);
        setTimeout(() => setCopySuccess(false), 2000);
      } else {
        console.error("Fallback copy failed.");
      }
    } catch (err) {
      console.error("Fallback: Unable to copy", err);
    }

    document.body.removeChild(textArea);
  };

  const handleShare = (platform) => {
    const fullUrl = `${shareUrl}`;
    let url = "";

    switch (platform) {
      case "whatsapp":
        url = `https://api.whatsapp.com/send?text=${whatsappMessage}`;
        break;
      case "facebook":
        url = `https://www.facebook.com/sharer/sharer.php?u=${encodeURIComponent(
          fullUrl
        )}`;
        break;
      case "twitter":
        url = `https://twitter.com/intent/tweet?url=${encodeURIComponent(
          fullUrl
        )}&text=${encodeURIComponent(shareTitle)}`;
        break;
      case "gmail":
        const subject = encodeURIComponent("Invitation");
        const body = encodeURIComponent(
          `Hi,\n\nI would like to invite you to this event:\n\n${shareUrl}\n\nBest Regards.`
        );
        url = `https://mail.google.com/mail/?view=cm&fs=1&to=&su=${subject}&body=${body}`;
        break;
      default:
        console.log("Invalid platform");
        return;
    }

    window.open(url, "_blank");
  };

  return (
    <Dialog
      header={<div>Invite</div>}
      visible={visible}
      style={{ width: "calc(100% - 15px)", maxWidth: "500px" }}
      modal
      onHide={onHide}
      headerStyle={{ margin: 0, padding: "15px 25px" }}
    >
      <div className="p-fluid">
        {/* Copy link */}

  <div style={{ marginBottom: "15px", textAlign: "center" }}>
   {imageloading ? (
          <h3 style={{ textAlign: "center" }}>
            <i
              className="pi pi-spin pi-spinner-dotted"
              style={{ fontSize: "2rem", color: "#0cc0df" }}
            ></i>
          </h3>
        ) : (
          image && (
         
                       <div className="image-preview">
                     <div className="single-image-container-forpreview">
                       {/* Preview */}
                       <div style={{ pointerEvents: "none", userSelect: "none" }}>
                         <div className="rsvp-wrapper-scaled">
                           <div className="rsvp-scaled-inner">
                             <RSVPInvitationPage_pooja
                     EventDataForInvitation={EventDataForInvitation}
                     imageUrl_as_prop={image}
                   />
                           </div>
                         </div>
                       </div>
                     </div>
                   </div>
          )
        )}

   
  </div>

        <div className="p-inputgroup mb-3">
          <div style={{ position: "relative", width: "100%" }}>
            <InputText
              value={shareUrl}
              readOnly
              style={{ flexGrow: 1, width: "100%", paddingRight: "58px" }}
            />
            <Button
              id="info-icon"
              label={copySuccess ? "Copied" : "Copy"}
              icon="pi pi-copy"
              onClick={handleCopy}
              style={{
                position: "absolute",
                right: "0",
                borderRadius: "0 6px 6px 0",
                backgroundColor: copySuccess ? "#FF895D" : "#0cc0df",
              }}
            />
            <Tooltip
              position="mouse"
              at="right+5 bottom"
              target="#info-icon"
              content="You can use this link to send invitation using any other method."
            />
          </div>
        </div>

        {/* Share buttons */}
        <div style={{ marginTop: "10px" }}>
          <label style={{ display: "block", marginBottom: "10px" }}>
            Share on Social Media
          </label>
          <div
            style={{
              display: "flex",
              justifyContent: "flex-start",
              alignItems: "center",
              gap: "10px",
            }}
          >
            <Button
              icon="pi pi-whatsapp"
              className="p-button-rounded"
              onClick={() => handleShare("whatsapp")}
              style={{ backgroundColor: "#25D366", color: "white" }}
              aria-label="WhatsApp"
            />
            <Button
              icon="pi pi-facebook"
              className="p-button-rounded"
              onClick={() => handleShare("facebook")}
              style={{ backgroundColor: "#3B5998", color: "white" }}
              aria-label="Facebook"
            />
            <Button
              icon="pi pi-twitter"
              className="p-button-rounded"
              onClick={() => handleShare("twitter")}
              style={{ backgroundColor: "#1DA1F2", color: "white" }}
              aria-label="Twitter"
            />
            <Button
              icon="pi pi-envelope"
              className="p-button-rounded"
              onClick={() => handleShare("gmail")}
              style={{ backgroundColor: "#ea4335", color: "white" }}
              aria-label="Gmail"
            />
          </div>
        </div>
      </div>
    </Dialog>
  );
};

export default SendInvitationDialog;
